function LinkedInIcon( { title = null } ) {
  return (
    <svg 
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{ title || 'LinkedIn' }</title>
      <path 
        d="M5.66977 21.63H0.809767V7.7H5.66977V21.63ZM15.7598 12.24C15.1922 12.24 14.6479 12.4655 14.2466 12.8668C13.8452 13.2681 13.6198 13.8124 13.6198 14.38V21.63H8.50977V7.7H13.6198V9.29C14.8175 8.27606 16.3306 7.71039 17.8998 7.69C21.0698 7.69 23.2698 10.04 23.2698 14.5V21.63H17.8998V14.38C17.9011 14.0981 17.8467 13.8188 17.7397 13.558C17.6328 13.2972 17.4754 13.0601 17.2765 12.8603C17.0777 12.6606 16.8413 12.502 16.581 12.3939C16.3207 12.2857 16.0416 12.23 15.7598 12.23V12.24ZM5.75977 2.88C5.75977 3.37446 5.61314 3.85781 5.33844 4.26893C5.06374 4.68005 4.67329 5.00048 4.21648 5.1897C3.75966 5.37892 3.25699 5.42843 2.77204 5.33197C2.28709 5.2355 1.84163 4.9974 1.492 4.64777C1.14237 4.29814 0.904267 3.85268 0.807804 3.36773C0.71134 2.88278 0.760849 2.38011 0.950068 1.9233C1.13929 1.46648 1.45972 1.07603 1.87084 0.801331C2.28196 0.526627 2.76531 0.380005 3.25977 0.380005C3.91934 0.385282 4.55009 0.651001 5.01462 1.11927C5.47914 1.58754 5.73979 2.22041 5.73977 2.88H5.75977Z"
        fill="#D9D9D9"
      />
    </svg>
  )
}

export default LinkedInIcon
